import { StrictMode } from 'react'
import './i18n'
import { createRoot } from 'react-dom/client'
import '@fontsource-variable/golos-text'
// Заголовки темы industrial (зеркало om). Файлы шрифта грузятся, только когда тема на экране.
import '@fontsource-variable/montserrat'
import './index.css'
import App from './App.tsx'

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>,
)
